import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const usePostInativarCondominioGroupPay = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["tabela-condominios-group-pay"]);
    toast.error(
      <div>
        <strong>Condomínio desativado</strong>
        <div>O condomínio não está mais ativo no Group Pay</div>
      </div>
    );
  };

  const { mutate, ...rest } = usePost({
    url: api.groupPay.postInativarCondominio,
    skipGlobalLoading: true,
    onSuccess,
  });

  const adaptedMutate = (idOrIds: number | number[]) => {
    const ids = Array.isArray(idOrIds) ? idOrIds : [idOrIds];
    return mutate({ ids: ids });
  };

  return {
    ...rest,
    mutate: adaptedMutate,
  };
};